export default "__VITE_ASSET__849c0053__"